import React from 'react'
import {TabPanel} from "@chakra-ui/react";
import {IProject} from "../../models/interfaces/project.interface.ts";
import MultiLanguageFeatureTableProgress from "./MultiLanguageFeatureTableProgress.tsx";
import {IGroupProgress} from "../../models/interfaces/groupProgress.interface.ts";


interface AudioDescriptionFeatureProgressProps {
  project: IProject;
}

const AudioDescriptionFeatureProgress: React.FC<AudioDescriptionFeatureProgressProps> = (
  {
    project
  }: AudioDescriptionFeatureProgressProps) => {

  return (
    <TabPanel>
      <div className="overflow-hidden rounded-md border border-n-600">
        <MultiLanguageFeatureTableProgress
          projectId={project.id}
          projectName={project.name}
          feature={project.featuresStates.audioDescriptions || {} as IGroupProgress}
          featureName={"audioDescriptions"}
        />
      </div>
    </TabPanel>
  )
}

export default AudioDescriptionFeatureProgress;